/*
 * Gallery Neighbour Warming
 * Slides other than the active one render loading="lazy" (snippets/media.liquid).
 * Once the browser is idle, promote the selected slide and its immediate neighbours
 * to eager so swiping doesn't start a cold fetch.
 *
 * Scoped to .flickity-slider descendants — that's the active variant image set only,
 * so other variants' images stay unloaded and the bandwidth saving is preserved.
 *
 * THEME UPDATE NOTE:
 * If theme is updated, re-add this line to layout/theme.liquid in <head>,
 * between mobile-thumb-autohide.js and theme.js:
 *   <script src="{{ 'gallery-warm-neighbours.js' | asset_url }}" defer="defer"></script>
 */

(function() {
  'use strict';

  var DEBOUNCE = 50;
  var IDLE_TIMEOUT = 2000;

  document.addEventListener('DOMContentLoaded', function() {
    var slideshow = document.querySelector('[data-product-photos]');
    if (!slideshow) return;

    function eager(slide) {
      if (!slide) return;
      slide.querySelectorAll('img[loading="lazy"]').forEach(function(img) {
        // Setting .loading on a not-yet-loaded lazy image triggers the fetch immediately
        img.loading = 'eager';
      });
    }

    function warm() {
      var current = slideshow.querySelector('.flickity-slider .product-main-slide.is-selected');
      if (!current) return;
      eager(current); // a variant switch can land on a slide that was still lazy
      eager(current.previousElementSibling);
      eager(current.nextElementSibling);
    }

    var idle = window.requestIdleCallback || function(cb) { return setTimeout(cb, 300); };
    var timer = null;

    function schedule() {
      clearTimeout(timer);
      timer = setTimeout(function() {
        idle(warm, { timeout: IDLE_TIMEOUT });
      }, DEBOUNCE);
    }

    window.addEventListener('load', schedule);

    // Same pattern as mobile-thumb-autohide.js: subtree is required because Flickity
    // wraps slides in .flickity-slider, childList catches the destroy/recreate on
    // variant change. attributeFilter is ['class'] so our own loading= writes can't
    // retrigger the observer.
    new MutationObserver(schedule).observe(slideshow, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
      childList: true
    });
  });
})();
